export default class ItemDashboard {
    codigoItem: string;
    nome: string;
    modulo: string;
    tipo: string = "";
    constructor(
        codigoItem: string = "",
        nome: string = "",
        modulo: string = "",
        tipo: string = ""
    ) {
        this.codigoItem = codigoItem;
        this.nome = nome;
        this.modulo = modulo;
        this.tipo = tipo;
    }
}